"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const proto_1 = __importDefault(require("@helium/proto"));
const Transaction_1 = __importDefault(require("./Transaction"));
const utils_1 = require("./utils");
class SecurityExchangeV1 extends Transaction_1.default {
    constructor(opts) {
        super();
        this.type = 'security_exchange_v1';
        this.payer = opts.payer;
        this.payee = opts.payee;
        this.amount = opts.amount;
        this.nonce = opts.nonce;
        if (opts.fee !== undefined) {
            this.fee = opts.fee;
        }
        else {
            this.fee = 0;
            this.fee = this.calculateFee();
        }
    }
    serialize() {
        const Txn = proto_1.default.helium.blockchain_txn;
        const securityExchange = this.toProto();
        const txn = Txn.create({ securityExchange });
        return Txn.encode(txn).finish();
    }
    async sign({ payer: payerKeypair }) {
        const SecurityExchange = proto_1.default.helium.blockchain_txn_security_exchange_v1;
        const securityExchange = this.toProto(true);
        const serialized = SecurityExchange.encode(securityExchange).finish();
        const signature = await payerKeypair.sign(serialized);
        this.signature = signature;
        return this;
    }
    toProto(forSigning = false) {
        const SecurityExchange = proto_1.default.helium.blockchain_txn_security_exchange_v1;
        return SecurityExchange.create({
            payer: this.payer ? utils_1.toUint8Array(this.payer.bin) : null,
            payee: this.payee ? utils_1.toUint8Array(this.payee.bin) : null,
            amount: this.amount,
            fee: this.fee && this.fee > 0 ? this.fee : null,
            nonce: this.nonce,
            signature: this.signature && !forSigning ? utils_1.toUint8Array(this.signature) : null,
        });
    }
    calculateFee() {
        this.signature = utils_1.EMPTY_SIGNATURE;
        const payload = this.serialize();
        return Transaction_1.default.calculateFee(payload);
    }
}
exports.default = SecurityExchangeV1;
//# sourceMappingURL=SecurityExchangeV1.js.map